import React, { Fragment, useState } from "react";
import Login from "../login";


const LandingPage = ({ show, handleClose, handleShow }) => {

  return (
    <Fragment>

      <Login show={show} handleClose={handleClose} handleShow={handleShow} />

      <div className="landing-container" >

        <h1 className="easy-money-title">Easy Money, <br /> Sweet as Honey.</h1>

        <iframe 
        width="560" 
        height="315" 
        src="https://www.youtube.com/embed/Xx9BLWgyYeY" 
        title="YouTube video player" 
        // frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen
        >
        </iframe>

      </div>
    </Fragment>
  );
};

export default LandingPage;
